import { Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './components/layout/MainLayout';
import GlobalLoader from './components/common/GlobalLoader';

// Auth Pages
import Login from './components/pages/auth/Login';
import ForgotPassword from './components/pages/auth/ForgotPassword';
import ResetPassword from './components/pages/auth/ResetPassword';
import LoginTwoFactor from './components/pages/auth/LoginTwoFactor';

// Dashboard Pages
import Dashboard from './components/pages/Dashboard';
import Roles from './components/pages/roles/Roles';
import AllUsers from './components/pages/users/AllUsers';
import SubscribedUsers from './components/pages/users/SubscribedUsers';
import Onboarding from './components/pages/Onboarding';
import SystemUsers from './components/pages/SystemUsers';
import SubscriptionPlans from './components/pages/SubscriptionPlans';
import ActionLogs from './components/pages/ActionLogs';
import UserLists from './components/pages/UserLists';
import InterestCategories from './components/pages/interests/Categories';
import InterestSubCategories from './components/pages/interests/Interest';
import Integrations from './components/pages/profileMetadata/Integrations';
import PromptGroup from './components/pages/profileMetadata/PromptGroup';
import Prompts from './components/pages/profileMetadata/Prompts';
import QuestionGroup from './components/pages/profileMetadata/QuestionGroup';

// Settings Pages
import Languages from './components/pages/settings/Languages';
import FAQCategories from './components/pages/settings/FAQ/Categories';
import FAQQuestions from './components/pages/settings/FAQ/Questions';
import ReportReasonCategories from './components/pages/settings/ReportReasons/ReportReasonCategories';
import ReportReasons from './components/pages/settings/ReportReasons/ReportReasons';
// import ReportUser from './components/pages/settings/ReportUser';
import TermsConditions from './components/pages/settings/Terms';
import PrivacyPolicy from './components/pages/settings/Privacy';
import AccountSettings from './components/pages/settings/AccountSettings';
import ApplicationSettings from './components/pages/settings/ApplicationSettings';

const App = () => {
  return (
    <>
      <GlobalLoader />
      <Routes>
        {/* Auth Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/login/two-factor" element={<LoginTwoFactor />} />

        {/* Protected Routes */}
        <Route element={<MainLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/roles" element={<Roles />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/system-users" element={<SystemUsers />} />
          <Route path="/interest" element={<InterestCategories />} />
          <Route path="/interest/:cat_id" element={<InterestSubCategories />} />
          <Route path="/subscription-plans" element={<SubscriptionPlans />} />
          <Route path="/action-logs/:action_type" element={<ActionLogs />} />
          <Route path="/user-lists" element={<UserLists />} />
          {/* Users Routes */}
          <Route path="/users">
            <Route path="all-users" element={<AllUsers />} />
            <Route path="subscribed-users" element={<SubscribedUsers />} />
          </Route>
          {/* Settings Routes */}
          <Route path="/settings">
            <Route path="languages" element={<Languages />} />
            <Route path="faq-categories" element={<FAQCategories />} />
            <Route path="faq-questions/:cat_id" element={<FAQQuestions />} />
            <Route path="report-reason-categories" element={<ReportReasonCategories />} />
            <Route path="report-reasons/:cat_id" element={<ReportReasons />} />
            <Route path="terms" element={<TermsConditions />} />
            <Route path="privacy" element={<PrivacyPolicy />} />
            <Route path="account" element={<AccountSettings />} />
            <Route path="application" element={<ApplicationSettings />} />
          </Route>
          <Route path="/profile-meta">
            <Route path="integrations" element={<Integrations />} />
            <Route path="prompt-group" element={<PromptGroup />} />
            <Route path="prompt-group/:group_id" element={<Prompts />} />
            <Route path="question-group" element={<QuestionGroup />} />
          </Route>

          {/* Redirect / to /dashboard */}
          <Route path="/" element={<Navigate to="/login" />} />
        </Route>
        {/* Catch-all redirect to / */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </>
  );
}
export default App;